import { people } from '@/mocks/home';

export default function People() {
  return (
    <section id="people" className="bg-background-100 sec">
      <div className="wrap">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-20" data-reveal>
          <h2 className="h-sec text-foreground-950">Senior.<br />Hands-on.</h2>
          <p className="text-[15px] leading-[1.6] text-foreground-700 max-w-[360px]">Every engagement is led by a partner, from the first conversation to the last.</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-12 border-t border-foreground-950/15 pt-8">
          {people.map((p) => (
            <figure key={p.name} data-reveal className="grid grid-cols-2 gap-6 md:gap-8 items-end">
              <div data-clip className="w-full aspect-[3/4] overflow-hidden bg-background-200">
                <img src={p.img} alt={`${p.name}, ${p.role} at AUREN`} title={`${p.name} — AUREN consulting`} className="w-full h-full object-cover object-top" />
              </div>
              <figcaption className="flex flex-col">
                <span className="label-xs text-foreground-600">{p.role}</span>
                <p className="h-card text-foreground-950 mt-3">{p.name}</p>
                <p className="text-sm text-foreground-700 mt-3 leading-[1.6] hidden sm:block">{p.note}</p>
                <span className="label-xs text-accent-700 mt-5 border-t border-foreground-950/15 pt-3">{p.focus}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}